import { createSlice } from "@reduxjs/toolkit";
import { get_req } from "../Utilities/apiUtil";
import { get_all_streets_by_city_url } from "../Utilities/apiUrl";
import { errorActions } from "../store/errorSlice";
import appConst from "../Utilities/appConst.json";

export const fetchAllStreets = (city, prefix) => {
  return async (dispatch) => {
    const fetchData = async () => {
      try {
        const data = await get_req(
          `${get_all_streets_by_city_url}&city=${city}`
        );
        dispatch(errorActions.setError(!data.isValid));
        return data;
      } catch (error) {
        dispatch(errorActions.setError(true));
      }
    };
    try {
      const streets = await fetchData();
      dispatch(errorActions.setError(!streets.isValid));
      dispatch(streetsActions.setStreets({ streets: streets, prefix: prefix }));
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
  };
};

const streetsSlice = createSlice({
  name: "streets",
  initialState: {
    streets: [],
    personalDetailsStreet: "",
    otherReciverStreets: [],
    businessInvoiceStreets: [],
    streetName: "",
    otherReseiverStreetName: "",
    businessInvoiceStreetName: "",
  },
  reducers: {
    setStreets: (state, action) => {
      switch (action.payload.prefix) {
        case appConst.OTHER_RECEIVER + "_":
          state.otherReciverStreets = [
            ...action.payload.streets.payload
              .map((street) => street.street_name)
              .slice(),
          ];
          break;
        case appConst.BUSINESS_INVOICE + "_":
          state.businessInvoiceStreets = [
            ...action.payload.streets.payload
              .map((street) => street.street_name)
              .slice(),
          ];
          break;
        default:
          state.streets = [
            ...action.payload.streets.payload
              .map((street) => street.street_name)
              .slice(),
          ];
      }
    },
    setStreetName: (state, action) => {
      switch (action.payload.prefix) {
        case appConst.OTHER_RECEIVER + "_":
          state.otherReseiverStreetName = action.payload.streetName;
          break;
        case appConst.BUSINESS_INVOICE + "_":
          state.businessInvoiceStreetName = action.payload.streetName;
          break;
        default:
          state.streetName = action.payload.streetName;
      }
    },
  },
});
export const streetsActions = streetsSlice.actions;
export default streetsSlice;
